import { Component, OnInit } from '@angular/core';
import {TitleService} from "../../services/title.service";

@Component({
  selector: 'app-impress',
  templateUrl: './impress.component.html',
  styleUrls: ['./impress.component.scss']
})
export class ImpressComponent implements OnInit {

  constructor(titleService: TitleService) {
    titleService.setTitle("Impressum")
  }

  ngOnInit(): void {
  }

}
